// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-simple-carousel{height:300px}.h-simple-carousel__item{height:100%;padding-right:3px}@media (min-width:768px){.h-simple-carousel__item{padding-right:8px}}.h-simple-carousel__item__img{position:relative;display:block;width:300px;height:100%;overflow:hidden;border-radius:2px}.h-simple-carousel__item__img__node{position:absolute;top:0;right:0;bottom:0;left:0;background-repeat:no-repeat;background-size:cover;-webkit-backface-visibility:hidden;backface-visibility:hidden}", ""]);
// Exports
module.exports = exports;
